import { render } from "./ConfirmPhone.vue?vue&type=template&id=54befcf0&scoped=true"
import script from "./ConfirmPhone.vue?vue&type=script&lang=js"
export * from "./ConfirmPhone.vue?vue&type=script&lang=js"

import "./ConfirmPhone.vue?vue&type=style&index=0&id=54befcf0&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54befcf0"]])

export default __exports__